import React from 'react';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

const StyledDashboardSectionHeading = styled(NuvoGrid)`
  padding: 8px 8px 0;

  h2 {
    margin: 0;
    font-size: 24px;
    line-height: 24px;
    font-weight: 400;
  }

  h4 {
    margin: 4px 0 0;
    font-size: 14px;
    font-weight: 300;
    line-height: 16px;
    color: ${color('custom', 'contrastText')};
  }
`;

export interface DashboardSectionHeadingProps
  extends React.ComponentProps<typeof NuvoGrid> {
  title: string;
  subtitle?: string;
}

const DashboardSectionHeading: React.FC<DashboardSectionHeadingProps> = ({
  title,
  subtitle,
  ...props
}) => {
  return (
    <StyledDashboardSectionHeading item {...props}>
      <h2>{title}</h2>
      {subtitle && <h4>{subtitle}</h4>}
    </StyledDashboardSectionHeading>
  );
};

export default React.memo(DashboardSectionHeading);